function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "pmrmos7nda",
  colorInterpolationFilters: "auto"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.200000 0 0 0 0 0.400000 0 0 0 0 0.800000 0 0 0 1.000000 0"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-53.000000, -19.000000) translate(53.000000, 19.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 15.5,
  fill: "#FFF",
  stroke: "#CCC"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  filter: "url(#pmrmos7nda)",
  transform: "translate(6.000000, 6.000000) translate(10.000000, 10.000000) rotate(-270.000000) translate(-10.000000, -10.000000)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#36C",
  fillRule: "nonzero",
  d: "M5.82 10.249c.137-.077.307-.064.428.033l.057.055.038.055c.022.038.037.08.045.124l.006.067v2.255l6.915.013-.002 1.516-6.913-.013v2.262l-.006.07c-.033.178-.19.314-.378.314-.068 0-.133-.018-.191-.05l-.055-.039-3.626-3.017-.049-.049c-.1-.12-.117-.289-.044-.426l.044-.065.05-.05 3.625-3.016.057-.04zm8.36-7.2l.056.04 3.626 3.017.049.049c.12.145.117.352 0 .491l-.05.05-3.625 3.016c-.069.058-.156.089-.246.089-.188 0-.345-.136-.378-.315l-.006-.069V7.155l-6.913.013-.002-1.516 6.915-.013V3.384c0-.068.018-.133.051-.191l.038-.055c.12-.145.326-.178.484-.088z"
}))))));

var SvgRouteArrow = function SvgRouteArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRouteArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/routeArrow.3a1e651c.svg";
export { ForwardRef as ReactComponent };